export enum ExDocumentType {
    PASSPORT = 1,
    UTILITY_BILL = 2,
    CARD = 3,
    SELFIE_PASSPORT = 4,
    SELFIE_CARD = 5
}
